import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/lookups";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg } from "../../utils/Helpers";

function* categoriesLookupSaga() {
  try {
    const response = yield call(apis.categoriesLookup);
    yield put(
      actions.categoriesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* subCategoriesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.subCategoriesLookup, payload);
    yield put(
      actions.subCategoriesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* countriesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.countriesLookup, payload);
    yield put(
      actions.countriesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* exportersLookupSaga({ payload }) {
  try {
    const response = yield call(apis.exportersLookup, payload);
    yield put(
      actions.exportersLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* companiesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.companiesLookup, payload);
    yield put(
      actions.companiesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* businessVerificationTypesLookupSaga({ payload }) {
  try {
    const response = yield call(
      apis.businessVerificationTypesLookup,
      payload
    );
    yield put(
      actions.businessVerificationTypesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* businessTypesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.businessTypesLookup, payload);
    yield put(
      actions.businessTypesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* businessVerificationStatusLookupSaga({ payload }) {
  try {
    const response = yield call(
      apis.businessVerificationStatusLookup,
      payload
    );
    yield put(
      actions.businessVerificationStatusLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* voucherCompaniesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.voucherCompaniesLookup, payload);
    yield put(
      actions.voucherCompaniesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* transactionPaymentReasonsLookupSaga({ payload }) {
  try {
    const response = yield call(
      apis.transactionPaymentReasonsLookup,
      payload
    );
    yield put(
      actions.transactionPaymentReasonsLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* transactionStatusLookupSaga({ payload }) {
  try {
    const response = yield call(
      apis.transactionStatusLookup,
      payload
    );
    yield put(
      actions.transactionStatusLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* rolesLookupSaga() {
  try {
    const response = yield call(apis.rolesLookup);

    yield put(
      actions.rolesLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}
function* pricingPlansLookupSaga() {
  try {
    const response = yield call(apis.pricingPlanLookup);

    yield put(
      actions.pricingPlansLookupResponse({
        list: response.data.Data
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* LookupsSagas() {
  yield takeEvery(
    types.CATEGORIES_LOOKUP_REQUEST,
    categoriesLookupSaga
  );
  yield takeEvery(
    types.SUB_CATEGORIES_LOOKUP_REQUEST,
    subCategoriesLookupSaga
  );
  yield takeEvery(
    types.COUNTRIES_LOOKUP_REQUEST,
    countriesLookupSaga
  );
  yield takeEvery(
    types.EXPORTERS_LOOKUP_REQUEST,
    exportersLookupSaga
  );
  yield takeEvery(
    types.COMPANIES_LOOKUP_REQUEST,
    companiesLookupSaga
  );
  yield takeEvery(
    types.BUSINESS_VERIFICATION_TYPES_LOOKUP_REQUEST,
    businessVerificationTypesLookupSaga
  );
  yield takeEvery(
    types.BUSINESS_TYPES_LOOKUP_REQUEST,
    businessTypesLookupSaga
  );
  yield takeEvery(
    types.BUSINESS_VERIFICATION_STATUS_LOOKUP_REQUEST,
    businessVerificationStatusLookupSaga
  );
  yield takeEvery(
    types.VOUCHER_COMPANIES_LOOKUP_REQUEST,
    voucherCompaniesLookupSaga
  );
  yield takeEvery(types.ROLES_LOOKUP_REQUEST, rolesLookupSaga);
  yield takeEvery(
    types.TRANSACTION_PAYMENT_REASONS_LOOKUP_REQUEST,
    transactionPaymentReasonsLookupSaga
  );
  yield takeEvery(
    types.TRANSACTION_STATUS_LOOKUP_REQUEST,
    transactionStatusLookupSaga
  );
  yield takeEvery(
    types.PRICING_PLANS_LOOKUP_REQUEST,
    pricingPlansLookupSaga
  );
}
